export enum AnswerType {
  YES = 'yes',
  NO = 'no',
  INQUIRE_ABOUT_KROMA_KRISTA = 'Inquire about KROMA™ / KRISTA™',
}
